export default __webpack_public_path__ + "static/media/auth-background.c4937c99.png";